import { insert } from "lib/utils";
import { replaceAssetVars, REGIONS, nodeTypeByDepth } from "../menuSlice";
import { titleFromPath } from "app/header/parts/HeaderTitle";

export const recurseMenuItems = (item, parent = {}) => {
  if (Array.isArray(item)) return recurseArr(item, parent);
  else if (item.link) return recurseLink(item);
  else if (typeof item === "object") return recurseObj(item, parent);
  else console.warn("Unrecognised object type:", item);
};

const recurseArr = (arr, parent) => {
  const regionLinks = findRegionLinks(arr);
  if (regionLinks.length) {
    arr = addRegionLinks(regionLinks[0], arr);
  }
  return arr.map((i) => recurseMenuItems(i, parent));
};

const recurseLink = (item) => {
  if (typeof item === "string") item = { link: item };
  item.link = replaceAssetVars(item.link);

  if (!item.label) item.label = titleFromPath(item.link);
  item.label = item.label.replace(/\?.*/, "").replace("__", "/");
  return item;
};

const recurseObj = (obj, parent = {}) => {
  const [key, arr] = Object.entries(obj)[0];

  if (obj.children) return recurseObjChildren(obj, parent);
  else if (!Array.isArray(arr)) return obj;
  else return createObjChildren(key, arr, parent);
};

const recurseObjChildren = (obj, parent) => ({
  ...obj,
  children: recurseMenuItems(obj.children, { ...obj, depth: parent.depth }),
});

const createObjChildren = (key, children, parent) => {
  const depth = (parent.depth || 0) + 1;
  const noCol = parent.col ? { noCol: 1 } : {};
  return {
    node: key,
    [nodeTypeByDepth[depth]]: key,
    children: recurseMenuItems(children, { node: key, depth }),
    depth: depth,
    ...noCol,
  };
};

const findRegionLinks = (arr) =>
  arr.filter(
    (item) =>
      (typeof item.link === "string" && item.link.includes("$region")) || (item.includes && item.includes("$region"))
  );

const addRegionLinks = (regionLink, items) => {
  const item = recurseLink(regionLink);
  const newLinks = REGIONS.map((region) => ({
    link: item.link.replace("$region", region),
    label: region,
  }));
  items = insert(items, items.indexOf(regionLink), newLinks);
  items = items.filter((i) => i !== regionLink);
  return items;
};
